module.exports = __webpack_public_path__ + "static/media/yellowBg.3713043a.jpg";